import { RoutePaths } from '@global/routePaths';
import { NavigationGuard } from '@core/guards/navigation.guard';

export const ThankYouRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.THANK_YOU.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/thank-you/thank-you.module').then(m => m.ThankYouPageModule),
    canActivate: [NavigationGuard],
  },
];
